import { memo, useState, VFC } from 'react'
import { DEFAULT_IMAGE } from 'src/assets/images'
import { DisplayIntroductoryText } from 'src/compositions/RequestBox/RequestBoxLayout'
import { SmallButton } from 'src/elements/Button'
import {
  _requestbox_item_border,
  accentColor,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import styled from 'styled-components'
import { Section } from './styles'
import { ProfilePreviewProps } from './types'

export const IsIntroductoryTextsSection: VFC<ProfilePreviewProps> = memo(
  ({
    user: {
      profile: { name },
      company: { introductoryTextCompanies },
    },
  }) => {
    const [page, setPage] = useState<number>(1)

    if (!introductoryTextCompanies || introductoryTextCompanies.length === 0)
      return <></>

    const displayLength = page * 3
    const canPaginate = introductoryTextCompanies.length > displayLength
    const data = introductoryTextCompanies.slice(0, displayLength)

    return (
      <Section>
        <h3>つながった方々からの{name}さんの紹介文</h3>
        <ConnectionCompaniesWrapper>
          <Wrapper>
            {data.map((company) => (
              <Item key={company.id}>
                <Flex>
                  <ItemCompanyInfo>
                    <ItemContentImage src={company.imageUrl || DEFAULT_IMAGE} />
                    <CompanyName>{company.name}</CompanyName>
                    <CompanyAdminName>{company.adminName}</CompanyAdminName>
                  </ItemCompanyInfo>
                  <IntroductoryTextWrapper>
                    <IntroductoryTextDiv>
                      <DisplayIntroductoryText content={company.content} />
                    </IntroductoryTextDiv>
                  </IntroductoryTextWrapper>
                </Flex>
              </Item>
            ))}
          </Wrapper>

          {canPaginate && (
            <Buttons>
              <ApproveButton onClick={() => setPage(page + 1)}>
                紹介文をもっと見る
              </ApproveButton>
            </Buttons>
          )}
        </ConnectionCompaniesWrapper>
      </Section>
    )
  },
)

const ConnectionCompaniesWrapper = styled.div`
  max-width: 700px;
  width: 100%;
  padding: 20px 40px;
  background-color: ${truewhite};
  border-radius: 10px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const Item = styled.div`
  padding: 20px 0;
`
const ItemContentImage = styled.img`
  border-radius: 50%;
  object-fit: cover;
  width: 69px;
  height: 69px;
`
const CompanyName = styled.p`
  padding-top: 8px;
  font-size: 14px;
  padding-bottom: 4px;
`
const CompanyAdminName = styled.p`
  font-size: 20px;
  font-weight: ${fontWeightBold};
`
const Flex = styled.div`
  display: flex;
`
const ItemCompanyInfo = styled.div`
  width: 130px;
  padding-right: 8px;
`
const IntroductoryTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`
const IntroductoryTextDiv = styled.div`
  padding: 20px;
  max-width: 460px;
  margin-bottom: 8px;
  white-space: pre-wrap;
  border-top: 1px solid ${_requestbox_item_border};
  border-bottom: 1px solid ${_requestbox_item_border};
`
const Buttons = styled.div`
  display: flex;
  gap: 24px;
  ${flexCenter};

  button {
    width: 140px;
    padding: 10px 0;
    color: ${truewhite};
  }
`
const ApproveButton = styled(SmallButton)`
  background: ${accentColor};
`
